import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { BasePageComponent } from '../../../core/classes/base-page';
import { HelpersService } from '../../../core/services/helpers.service';
import { MatDialog } from '@angular/material/dialog';
import { LoadingService } from '../../../core/services/loading.service';
import { CashAdvanceService } from '../../../core/api/cash-advance.service';
import { AuthService } from '../../../core/services/auth.service';
import { FileService } from '../../../core/api/file.service';
import { debounceTime } from 'rxjs';
import { CheckSelect } from '../../../core/classes/check-select';
import { CashAdvanceApprovalService } from '../../../core/api/cash-advance-approval.service';
import { FilePreviewComponent } from '../../../components/file-preview/file-preview.component';

@Component({
  selector: 'app-cash-advance-approval',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    RouterModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
  ],
  templateUrl: './cash-advance-approval.component.html',
  styleUrl: './cash-advance-approval.component.scss',
})
export class CashAdvanceApprovalComponent
  extends BasePageComponent<any>
  implements OnInit
{
  searchFormControl = new FormControl();
  counter = {
    all: 0,
    received: 0,
    draft: 0,
    sent: 0,
    approved: 0,
    reimbursed: 0,
    rejected: 0,
  };
  currentFilter: any;

  constructor(
    public override helpers: HelpersService,
    public override router: Router,
    public override activatedRoute: ActivatedRoute,
    public override dialog: MatDialog,
    public override loading: LoadingService,
    public override service: CashAdvanceApprovalService,
    public override authService: AuthService,
    private fileService: FileService
  ) {
    super(
      helpers,
      router,
      activatedRoute,
      dialog,
      loading,
      service,
      authService
    );
    this.displayedColumns = [
      'no',
      'refId',
      'requester',
      'file',
      'title',
      'expanse_category',
      'status',
      'date',
      'amount',
      'action',
    ];
    this.sortActive = 'updated_at';
    this.sortDirection = 'desc';
    this.subject = 'refId';
    this.q.status = 'all';
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.searchFormControl.valueChanges
      .pipe(debounceTime(300))
      .subscribe((val: any) => {
        this.q.search = val;
        this.getData();
      });
  }

  override afterInit(): void {
    this.getData();
  }

  override getData(): void {
    this.loading.startLoading();
    this.service
      .getAllApproval(this.q)
      .then((data) => {
        this.assignData(data.cashAdvance);
        this.afterGetData();
        this.counter['received'] = data.receivedCount;
        this.counter['approved'] = data.approvedCount;
        this.counter['rejected'] = data.rejectedCount;
        this.counter['all'] = data.allCount;
        this.loading.endLoading();
      })
      .catch((err) => {
        this.helpers.sbError(err);
        this.loading.endLoading();
      });
  }

  override afterGetData(): void {
    console.log(this.dataTotal);
  }

  detailReimburse(id: any) {
    this.router.navigate(['/dashboard/cash-advance-approval/action'], {
      queryParams: {
        m: 'detail',
        id,
      },
    });
  }

  download(item: any) {
    const targetFile = this.helpers.resolveTargetFile(item);
    if (targetFile?.id) {
      this.dialog
        .open(FilePreviewComponent, {
          width: '70vw',
          maxWidth: '70vw',
          maxHeight: '95vh',
          data: targetFile,
        })
        .afterClosed()
        .subscribe((item) => {
          if (item) {
          }
        });
    } else {
      this.helpers.sbError('Tidak ada file yang bisa diunduh');
    }
  }

  getFileItems(element: any): any[] {
    return this.helpers.normalizeFileItems(element);
  }

  getRequesterName(element: any): string {
    const firstName = element.cashadvance?.creator?.firstName ?? '';
    const lastName = element.cashadvance?.creator?.lastName ?? '';
    const fullName = `${firstName} ${lastName}`.trim();
    return fullName || '-';
  }

  changeFilter(filter: any): void {
    if (this.currentFilter === filter || filter == null) {
      this.currentFilter = 'received';
    } else {
      this.currentFilter = filter;
    }
    this.q.status = this.currentFilter;
    this.getData();
  }

  override onSortChange(sort: Sort): void {
    const { active, direction } = sort;
    if (!active || !direction) {
      this.assignData([...(this.data || [])]);
      return;
    }

    const normalized = [...(this.data || [])].sort((a: any, b: any) => {
      const av = this.getSortableValue(a, active);
      const bv = this.getSortableValue(b, active);
      if (av == null && bv == null) return 0;
      if (av == null) return 1;
      if (bv == null) return -1;
      if (av < bv) return direction === 'asc' ? -1 : 1;
      if (av > bv) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    this.assignData(normalized);
    this.afterGetData();
  }

  private getSortableValue(element: any, key: string): any {
    const cashadvance = element?.cashadvance ?? {};
    if (key === 'refId') return cashadvance.refId ?? '';
    if (key === 'title') return (cashadvance.title ?? '').toLowerCase();
    if (key === 'status') return (cashadvance.status ?? '').toLowerCase();
    if (key === 'date') return new Date(cashadvance.startDate ?? 0).getTime();
    if (key === 'amount') return Number(cashadvance.amount ?? 0);
    return '';
  }
}
